module.exports = {"330802005":"新新街道","330802006":"府山街道","330802007":"荷花街道","330802008":"信安街道","330802009":"白云街道","330802010":"双港街道","330802012":"衢化街道","330802013":"花园街道","330802100":"石梁镇","330802101":"航埠镇","330802205":"黄家乡","330802209":"七里乡","330802210":"九华乡","330802211":"沟溪乡","330802212":"华墅乡","330802213":"姜家山乡","330802214":"万田乡","330802215":"石室乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330802.json
// module id = 927
// module chunks = 0